module.exports = __webpack_public_path__ + "static/img/bg-news.2505407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-news.jpg
// module id = A/Fk
// module chunks = 30